import React from 'react';
import styles from './styles.module.scss';
import { openFormInCaseOfNewOrgAndFreemiumUser } from '../../../helpers/jsHelper';

const UpgradeCardBanner = ({
  title = 'Share the full experience',
  description = 'Upgrade your plan to remove watermark and share AR, Video and, Product Configurator.',
  btnName = 'Upgrade now',
}) => {
  
  const handleSubmit = () => {
    openFormInCaseOfNewOrgAndFreemiumUser();
    return
  }

  return (
    <div className={styles.card}>
      <div>
        <div className={styles.titleContainer}>
          <h1 className={styles.mainTitle}>{title}</h1>
        </div>
        {description && <p className={styles.description}>{description}</p>}
      </div>
      <button className={styles.upgradeButton} onClick={handleSubmit}>{btnName}</button>
    </div>
  );
};

export default UpgradeCardBanner;
